import { PropertyModel } from 'src/app/shared/models/property-model';
import { MandateModel } from './../../shared/models/mandate-model';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from './../../shared/services/local-storage.service';
import { PropertyService } from 'src/app/shared/services/property.service';
import { MatDialog } from '@angular/material/dialog';
import { environment } from './../../../environments/environment';
import { LoaderPopupComponent } from './../../shared/components/loader-popup/loader-popup.component';
import { CustomPopupComponent } from './../../shared/components/custom-popup/custom-popup.component';
import { Component, OnInit } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
@Component({
  selector: 'app-property-mandate',
  templateUrl: './property-mandate.component.html',
  styleUrls: ['./property-mandate.component.scss'],
})
export class PropertyMandateComponent implements OnInit {
  public propertyNeeds: any = {};
  public mandate: MandateModel[] = [];
  public mandate_file: boolean = false;
  public file_name: string;
  public media: any;
  public file_key: string;
  public old_file_key: string;
  public mandate_id: string;
  public user_id: string;
  public property_id: string;

  constructor(
    private localStorageService: LocalStorageService,
    private dialog: MatDialog,
    private propertyService: PropertyService,
    private route: ActivatedRoute
  ) {
    this.user_id = this.localStorageService.getCurrentUser().id;
    this.property_id = this.route.snapshot.paramMap.get('property_id');
  }

  ngOnInit(): void {
    this.getPropertyMandate();
    this.getNeedsForSaleOrRent();
  }

  /**
   * getNeedsForSaleOrRent
   */
  public getNeedsForSaleOrRent() {
    this.propertyService
      .getNeedsForSaleOrRent(this.property_id)
      .subscribe((res) => {
        console.log('res', res);
        if (res && res.data.getProperty) {
          const data = new PropertyModel().transformPropertyNeeds(
            res.data.getProperty
          );
          this.propertyNeeds = data;
          console.log(this.propertyNeeds);
        }
      });
  }
  /**
   * getPropertyMandate
   */
  public getPropertyMandate() {
    this.propertyService
      .getPropertyMandate(this.property_id)
      .subscribe((res: any) => {
        console.log('res', res);
        const data = res.data.getPropertyMandate;
        console.log('data', data.id);

        if (res && res.data.getPropertyMandate) {
          this.mandate_file = true;
          const mandateModel = new MandateModel().mapToModel(
            res.data.getPropertyMandate
          );
          console.log(mandateModel);
          this.mandate.push(mandateModel);
          this.mandate.forEach((element) => {
            console.log(element);
            this.mandate_id = element.ID;
            this.file_key = element.File;
            this.old_file_key = element.File;
          });
        } else {
          return;
        }
      });
  }

  /**
   * makeOffer
   */
  public makeOffer($event) {
    console.log($event);
    this.dialog.open(LoaderPopupComponent, {
      disableClose: true,
      hasBackdrop: true,
      height: '40%',
      panelClass: 'custom-modalbox',
      data: {
        text: 'Téléchargement en cours ... ',
        isLoader: true,
      },
    });
    var file = $event.target.files[0]; // FileList object

    var end_file_name = file.name.split('.')[1]; // End of string file_name

    var fieldName = $event.field_name; // Fieldname of file

    this.file_name = 'assets-upload/mandate-' + uuidv4() + '.' + end_file_name; // Set a random file_name

    // If size of file bigger than 3 mega bytes throw Error
    if (file.size > 3145728) {
      this.dialog.closeAll();
      const dialogRef = this.dialog.open(CustomPopupComponent, {
        disableClose: true,
        hasBackdrop: true,
        height: '70%',
        panelClass: 'custom-modalbox',
        data: {
          status: 'error',
          title: "Une erreur s'est produite",
          message:
            'La taille du fichier ne doit pas excéder 3 méga octets (3 Mo)',
        },
      });
      this.file_name = '';
    } else {
      this.getBase64(file).then((data) => {
        this.media = data;
        this.dialog.closeAll();
        this.propertyService
          .addMandate(
            this.user_id,
            this.media,
            this.file_name,
            this.property_id,
            this.old_file_key
          )
          .subscribe((res: any) => {
            console.log(res);
            if (res && res.data.addMandate.code === 'MANDATE_FILE_UPLOADED') {
              this.dialog.closeAll();
              window.location.reload();
            }
          });
      });
    }
  }

  /**
   * getBase64
   * Function to transform file into base64
   */
  public getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  /**
   * getFile
   */
  public getFile($event) {
    let file_url = environment.cloudfront_url + this.file_key;
    if (this.mandate_file) {
      window.open(`${file_url}`, 'blank');
    }
  }

  /**
   * REMOVE FILE UPLOADED
   */
  public removeFile($event) {
    const dialogRef = this.dialog.open(CustomPopupComponent, {
      disableClose: true,
      hasBackdrop: true,
      height: '70%',
      panelClass: 'custom-modalbox',
      data: {
        status: 'delete',
        title: 'ATTENTION',
        message: 'Etes-vous sur de vouloir supprimer ce fichier ?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dialog.closeAll();
        this.dialog.open(LoaderPopupComponent, {
          disableClose: true,
          hasBackdrop: true,
          height: '40%',
          panelClass: 'custom-modalbox',
          data: {
            text: 'Suppression en cours... ',
            isLoader: true,
          },
        });
        this.propertyService
          .removeMandate(this.file_key, this.mandate_id)
          .subscribe((res: any) => {
            console.log(res);
            if (
              res &&
              res.data.removeMandate.code ===
                'PROPERTY__MANDATE_SUCCESSFULLY_REMOVED'
            ) {
              this.dialog.closeAll();
              window.location.reload();
            } else if (res.errors.message) {
              this.dialog.closeAll();
              this.dialog.open(CustomPopupComponent, {
                disableClose: true,
                hasBackdrop: true,
                height: '70%',
                panelClass: 'custom-modalbox',
                data: {
                  status: 'error',
                  title: "Une erreur s'est produite",
                  message:
                    'Nous sommes désolé, un problème est survenu. Veuillez réessayer ultérieurement.',
                },
              });
            }
          });
      } else {
        this.dialog.closeAll();
      }
    });
  }
}
